import api from '../axios'
import type { AuthApi, LoginRequest, LoginResponse, MfaChallengeRequest, MfaSetupResponse, WebAuthnRegisterOptions, WebAuthnLoginOptions } from '../types'
import type { User } from '@/types/entities'

export const authApi: AuthApi = {
    login: (data: LoginRequest) => {
        // Security: Never log passwords - only log email for debugging
        if (import.meta.env.DEV) {
            console.log('Login request:', { email: data.email, hasPassword: !!data.password })
        }
        return api.post<LoginResponse>('/auth/login', data)
    },

    checkMfa: (email: string) => {
        return api.post<{
            requiresPassword: boolean
            mfaMethods: string[]
            passwordlessAvailable: boolean
            webauthnNeedsSetup: boolean
            totpNeedsSetup: boolean
        }>('/auth/check-mfa', { email })
    },

    logout: () => {
        return api.post('/auth/logout')
    },

    me: () => {
        return api.get<{ user: User }>('/auth/me')
    },

    refresh: () => {
        return api.post('/auth/refresh')
    },

    // MFA
    mfaChallenge: (data: MfaChallengeRequest) =>
        api.post<{ user: User }>('/auth/totp/challenge', {
            email: data.email,
            totpCode: data.code
        }),

    mfaSetup: () =>
        api.post<MfaSetupResponse>('/auth/totp/setup'),

    mfaConfirm: (data: MfaChallengeRequest) =>
        api.post('/auth/totp/confirm', data),

    // TOTP
    totpSetup: () =>
        api.post<MfaSetupResponse>('/auth/totp/setup'),

    totpInitialSetup: (email: string) =>
        api.post<MfaSetupResponse>('/auth/totp/initial-setup', { email }),

    totpVerify: (data: { token: string; email?: string }) =>
        api.post<{ user: User }>('/auth/totp/verify', { code: data.token, email: data.email }),

    // WebAuthn
    webauthnRegisterOptions: () =>
        api.post<WebAuthnRegisterOptions>('/auth/webauthn/register/options'),

    webauthnRegisterVerify: (data: any) =>
        api.post('/auth/webauthn/register/verify', data),

    webauthnLoginOptions: () =>
        api.post<WebAuthnLoginOptions>('/auth/webauthn/login/options'),

    webauthnLoginVerify: (data: any) =>
        api.post<{ user: User }>('/auth/webauthn/login/verify', data),
}
